import { Music, Users, Calendar, Search, Star, TrendingUp } from 'lucide-react';
import SEOLandingPage from '../../components/seo/SEOLandingPage';

export default function MusikerFindenSchweiz() {
  return (
    <SEOLandingPage
      title="Musiker finden in der Schweiz | jamnation - Die Musikerplattform"
      description="Finde die besten Musiker in der ganzen Schweiz auf jamnation. Gitarristen, Schlagzeuger, Bassisten, Sänger und mehr. Kostenlose Suche und direkte Kontaktaufnahme."
      h1="Musiker finden in der Schweiz"
      heroText="Entdecke talentierte Musiker aus der ganzen Schweiz. Egal ob für deine Band, ein Projekt oder eine Session – bei jamnation findest du die passenden Musikerinnen und Musiker für jedes Genre."
      keywords={[
        'musiker finden schweiz',
        'musiker suchen schweiz',
        'band musiker schweiz',
        'gitarrist finden schweiz',
        'schlagzeuger finden schweiz',
        'bassist finden schweiz',
        'sänger finden schweiz',
        'musikerplattform schweiz',
      ]}
      locationName="Schweizweit"
      ctaButtons={[
        {
          text: 'Alle Musiker entdecken',
          link: '/musicians',
          primary: true,
        },
        {
          text: 'Bands durchsuchen',
          link: '/bands',
        },
      ]}
      features={[
        {
          icon: Search,
          title: 'Gezielte Musikersuche',
          description:
            'Finde Musiker nach Instrument, Genre, Erfahrungslevel und Standort. Unsere erweiterte Suche hilft dir, genau die richtigen Leute zu finden.',
          link: '/musicians',
        },
        {
          icon: Users,
          title: 'Aktive Community',
          description:
            'Verbinde dich mit hunderten aktiven Musikern aus allen Kantonen der Schweiz. Von Hobby-Musikern bis zu Profis.',
          link: '/musicians',
        },
        {
          icon: Music,
          title: 'Alle Genres',
          description:
            'Rock, Pop, Jazz, Metal, Hip-Hop, Klassik und mehr. Bei jamnation findest du Musiker für jedes Genre und jeden Stil.',
          link: '/musicians',
        },
        {
          icon: Calendar,
          title: 'Events & Konzerte',
          description:
            'Sieh dir an, wo Musiker und Bands live auftreten. Perfekt zum Networking und um neue Talente zu entdecken.',
          link: '/agenda',
        },
        {
          icon: Star,
          title: 'Verifizierte Profile',
          description:
            'Alle Musiker-Profile mit Soundbeispielen, Videos und detaillierten Informationen zu Erfahrung und Equipment.',
          link: '/musicians',
        },
        {
          icon: TrendingUp,
          title: 'Kostenlos & Einfach',
          description:
            'Komplett kostenlose Registrierung und Nutzung. Erstelle dein Profil in wenigen Minuten und starte deine Suche.',
          link: '/become-musician',
        },
      ]}
      teaserSection={{
        title: 'Was du auf jamnation alles tun kannst',
        description:
          'jamnation ist mehr als nur eine Musikersuche. Hier kannst du deine Band präsent machen und dich mit der ganzen Schweizer Musikszene vernetzen.',
        items: [
          'Erstelle ein Profil für deine Band und zeige, was ihr drauf habt',
          'Veröffentliche bevorstehende Konzerte und erreiche mehr Publikum',
          'Teile Geschichten und Erlebnisse aus dem Bandalltag',
          'Lade Hörproben und Songs hoch, damit Fans deine Musik entdecken',
          'Vernetze dich mit anderen Musikern und Bands aus der ganzen Schweiz',
          'Werde als Band für Events und private Feiern gebucht',
        ],
      }}
      seoTeaser={{
        title: 'Die ganze Schweizer Musikszene vereint',
        description:
          'Von Genf bis St. Gallen, von Basel bis Lugano – jamnation verbindet Musiker aus der ganzen Schweiz. Egal ob du einen Bassisten in Zürich, eine Sängerin in Bern oder einen Keyboarder in Lausanne suchst: Unsere Plattform macht es einfach, die richtigen Musiker zu finden. Mit intelligenten Suchfiltern nach Instrument, Genre, Erfahrungslevel und Standort findest du schnell passende Bandmitglieder für dein Projekt. Höre dir Soundbeispiele an, sieh dir bisherige Projekte an und nimm direkt Kontakt auf – alles kostenlos. Ob Hobby-Band oder professionelles Studio-Projekt, ob Rock, Jazz, Hip-Hop oder Electronic – die Schweizer Musikszene wartet auf dich. Registriere dich jetzt und werde Teil der grössten Musikerplattform der Schweiz.',
      }}
      faqItems={[
        {
          question: 'Wie finde ich den richtigen Musiker für meine Band?',
          answer:
            'Nutze unsere erweiterte Suche, um nach Instrument, Genre, Standort und Erfahrungslevel zu filtern. Du kannst dir dann die Profile ansehen, Soundbeispiele anhören und direkt Kontakt aufnehmen.',
        },
        {
          question: 'Ist die Nutzung von jamnation kostenlos?',
          answer:
            'Ja, jamnation ist komplett kostenlos. Du kannst dich registrieren, ein Profil erstellen, nach Musikern suchen und diese kontaktieren – alles ohne Kosten.',
        },
        {
          question: 'Welche Musiker kann ich auf jamnation finden?',
          answer:
            'Du findest Musiker aller Instrumente: Gitarristen, Bassisten, Schlagzeuger, Keyboarder, Sänger, Bläser und viele mehr. Sowohl Anfänger als auch erfahrene Profis sind vertreten.',
        },
        {
          question: 'Kann ich auch als Musiker gefunden werden?',
          answer:
            'Absolut! Erstelle einfach dein kostenloses Musikerprofil mit deinen Fähigkeiten, Genres und Soundbeispielen. So können andere dich finden und kontaktieren.',
        },
        {
          question: 'In welchen Städten kann ich Musiker finden?',
          answer:
            'jamnation deckt die ganze Schweiz ab – von Zürich über Bern, Basel, Genf, Luzern bis in kleinere Städte und Gemeinden. Nutze die Standortfilter für deine Region.',
        },
      ]}
    />
  );
}
